export default "__VITE_ASSET__cATSDkZA__"